export const GenderStatus = [
  { label: 'message.payee.female', isInternationalization: true, value: '0' },
  { label: 'message.payee.male', isInternationalization: true, value: '1' },
];
export const ProfessionStatus = [
  { label: 'message.payee.legalPerson', isInternationalization: true, value: '0301' },
  { label: 'message.payee.selfPerson', isInternationalization: true, value: '0401' },
  { label: 'message.payee.liberalProfessions', isInternationalization: true, value: '2101' },
];
export const PayeeStatus = [
  { label: 'message.status.succeed', isInternationalization: true, value: 'S' },
  { label: 'message.status.processing', isInternationalization: true, value: 'P' },
  { label: 'message.status.fail', isInternationalization: true, value: 'F' },
];
